import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/articles';

export default function SiteNav() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const path = location.pathname;
  const navItems = [
    { label: '首页', to: '/' },
    ...categories.map((c) => ({ label: c.name, to: `/column/${c.id}` })),
    { label: '关于', to: '/about' },
  ];

  const close = () => setOpen(false);

  return (
    <header className="sticky top-0 z-40 border-b border-cream-200 bg-cream-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="group flex items-center gap-2" aria-label="校园爆点首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-xl text-cream-50">
            <i className="ri-fire-fill" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl text-primary-600">校园爆点</span>
            <span className="hidden text-[10px] tracking-widest text-ink-600 sm:block">
              CAMPUS BUZZ
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => {
            const active =
              item.to === '/' ? path === '/' : item.to !== '/about' && path.startsWith(item.to);
            const isAbout = item.to === '/about';
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`relative whitespace-nowrap rounded-full px-3 py-2 text-sm transition-colors ${
                  active
                    ? 'bg-primary-100 font-bold text-primary-700'
                    : 'text-ink hover:bg-cream-100 hover:text-primary-600'
                } ${isAbout && !active ? 'ml-1 rounded-full border border-cream-300 px-4' : ''}`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-cream-300 text-lg text-ink lg:hidden"
          aria-label="打开菜单"
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </div>

      {open && (
        <nav className="border-t border-cream-200 bg-cream-50 px-4 pb-4 pt-2 lg:hidden" aria-label="移动端导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={close}
              className="block rounded-lg px-3 py-2.5 text-sm text-ink hover:bg-primary-100 hover:text-primary-700"
            >
              {item.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}